/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

import type { ErrorWriteLogParam } from '@veeam-vspc/models/web-controllers';

import type { BaseRequestData } from '../../../interfaces';
import type { TransportRequestOptions, TransportService } from '../../../core';

export class ErrorSupplier {

    protected readonly transportService: TransportService<Error>;

    constructor(transportService: TransportService<Error>) {
        this.transportService = transportService;
    }

    writeLog(url: string, data: ErrorWriteLogParam & BaseRequestData, options?: TransportRequestOptions) {
        return this.transportService.request<ErrorWriteLogParam, {} | Error>(url, data, options);
    }

}
